document.addEventListener("DOMContentLoaded", () => {
    const acuityTriggersArr = Array.from(document.querySelectorAll(".acuity-custom-trigger"));
     
    const openInfo = (url) => {
        var html = `
          <div class="container">
          <iframe src="${url}" class="acuity-custom-frame" title="Schedule Appointment" width="100%" height="800" frameBorder="0"></iframe>
          <script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript" defer="defer"></script>  
          </div>`
        $s.openModal(html, 'popup-services');
    }

    acuityTriggersArr.forEach((btn, idx)=>{
        const url = btn.getAttribute('data-iframe-url')
        btn.addEventListener('click', function () {return openInfo(url)}); 
    })
})